import { MenuContext, initState } from "@component/core/Context/Menu/MenuContext";
import { MenuContextState } from "@component/core/Context/Menu/typeDefs";
import { useState } from "react";
import merge from "@lib/merge";
const tag = "@component/core/Context/Menu/MenuContextProvider";
export function MenuContextProvider({
  children
}) {
  const [state, setState] = useState(initState);
  const data = {
    menu: state,
    setMenu: (diff: Partial<MenuContextState>) => {
      const s = merge(state, diff);
      setState(s);
    }
  };
  if (process.env.NODE_ENV === 'development') {
    window["web"].context.menu = data;
  }
  return <MenuContext.Provider value={data}>
            {children}
        </MenuContext.Provider>;
}
export default MenuContextProvider;